import Vue from 'vue'
import App from './App.vue'
import router from './router'
import "./utils/permission"
import Banner from "@/components/Banner/index.vue"

Vue.component('Banner', Banner)
new Vue({
  render: h => h(App),
  router
}).$mount('#app')
